import { useCallback, useMemo } from 'react'

const useUndo = () => {
  const canUndo = useMemo(() => false, [])

  /**
   * Handles the undo action for the working rectangle if exists.
   */
  const handleUndo = useCallback(() => {}, [])

  return {
    handleUndo,
    canUndo,
  }
}

export default useUndo
